var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_108",
    "data-name": "Rettangolo 108",
    width: 512,
    height: 512,
    transform: "translate(1360)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_272",
    "data-name": "Raggruppa 272",
    transform: "translate(-1360)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_760",
    "data-name": "Tracciato 760",
    d: "M1872,256c0-141.385-114.61-256-256-256s-256,114.615-256,256c0,127.777,93.62,233.685,216,252.89V330h-65V256h65V199.6c0-64.16,38.22-99.6,96.7-99.6,28,0,57.3,5,57.3,5v63h-32.28c-31.8,0-41.72,19.734-41.72,39.979V256h71l-11.35,74H1656V508.89C1778.38,489.685,1872,383.777,1872,256Z",
    fill: "#1877f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_761",
    "data-name": "Tracciato 761",
    d: "M1715.65,330,1727,256h-71V207.979c0-20.246,9.92-39.979,41.72-39.979H1730V105s-29.3-5-57.31-5c-58.47,0-96.69,35.44-96.69,99.6V256h-65v74h65V508.89a258.791,258.791,0,0,0,80,0V330Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.470e727021b1aeef3db9be1470b8f2e8.svg";
export { ForwardRef as ReactComponent };